import { ReactNode, FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { paymentInfoAction } from 'src/store/payment';

interface Props {
  children: ReactNode;
}

const PaymentProvider: FC<Props> = ({ children }: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const { tenantId } = useAppSelector((state) => state.user.data);

  useEffect(() => {
    if (tenantId) dispatch(paymentInfoAction());
  }, [tenantId]);

  return <>{children}</>;
};

export default PaymentProvider;
